export function LogoSplash({ onClick, testId = "logo-splash" }) {
  return (
    <div onClick={onClick} className="fixed inset-0 z-[70] bg-white flex items-center justify-center p-4 sm:p-8" data-testid={testId} aria-label="Loading">
      <img src="/brand/logo-square.jpg" alt="Digital Nomad Nicaragua" className="w-full h-full object-contain animate-pulse" />
    </div>
  );
}
